import React from "react";
import OrderDetail from './OrderDetail';
import { getOrderDetails } from '../../accessors/GraphQLAccessor';
import OrderDetailLoading from './OrderDetailLoading';

import appMetrics from '../../common/MetricsService';
import MetricsConstants from '../../common/MetricsConstants';
import * as KatalMetrics from '@amzn/katal-metrics';
import { AppContext } from "../../AppContext";

class OrderDetailHOC extends React.Component<any, any> {
  

  constructor(props: any) {
    super(props);
    this.state = {
      deliveryID: null,
      view: <OrderDetailLoading/>,
    }
  }

  componentDidMount() {
    const actionMetricsPublisher = appMetrics.getMetricsPublisherForMethod("OrderDetail");
    const attemptMetric = new KatalMetrics.Metric.TimedAttempt(MetricsConstants.METRIC_LOAD_PAGE_DATA).withMonitor();

    const orderId = this.props.match.params.orderId;

    getOrderDetails(orderId)
      .then((response: any) => {
        this.setState({
          view: <OrderDetail order={response.data.order}/>
        });
        attemptMetric.setSuccess();
        actionMetricsPublisher.publish(attemptMetric);
      })
      .catch(() => {
        this.setState({
          view: (<pui-text id="order-detail-page-error" data-csa-c-content-id="order-detail-page-error" data-csa-c-type="card" data-csa-c-slot-id="order-detail">Error</pui-text>),
        });
        attemptMetric.setFailure();
        actionMetricsPublisher.publish(attemptMetric);
      });

  }

  refresh() {
    const orderId = this.props.match.params.orderId;
    
    getOrderDetails(orderId)
      .then((response: any) => {
        this.setState({
          view: <OrderDetail order={response.data.order}/>
        })
      })
      .catch(() => {
        this.setState({
          view: (<pui-text data-csa-c-content-id="order-detail-refresh-page-error" data-csa-c-type="card" data-csa-c-slot-id="order-detail">Error</pui-text>),
        })
      });
  }

  render() {
    return (this.state.view);
  }
}

OrderDetailHOC.contextType = AppContext;

export default OrderDetailHOC

